<template>

<div class="image-form">
    <div class="boxes">
        <div class="upload-box" :class="{'invalid': invalid}" >
            <div class="loading animated fadeIn" v-if="uploading">
                <i class="icon_loading animate-spin"></i>
            </div>
            <p :class="{'with-file':value && value.id>0}">{{placeholder}}</p> 
            <input type="file" @change="upload" ref="file">
            <div class="background" v-if="value" :style="'background-image:url('+thumbUrl(value)+')'"></div>
            <div class="invalid-feedback d-block" v-if="invalid">Suba una imagen</div>
        </div>
    </div>
</div>
</template>

<script>
import { uploadFileToGcs } from '@/lib/gcsUpload'
import { resolveFileThumb } from '@/lib/fileUrl'

export default {
	name: "uploadFiles",
	props:{
		value:{
            type: Object,
        },
		placeholder: {
            type: String
        },
		invalid: {
            type: Boolean
        },
    },
    data() {
        return {
            uploadedImage:{},
            uploading:false,
            backgroundImage: null,
            API_URL: process.env.VUE_APP_API_URL,
        }
    },
	methods:{
        thumbUrl(file) {
            return resolveFileThumb(file)
        },
		upload(event){
            this.uploading=true;
            var input = event.target;
			if (input.files && input.files[0]) {
				if( input.files[0].type == "image/jpeg" || input.files[0].type == "image/png" || input.files[0].type == "image/gif" ){
					return uploadFileToGcs(this.$apollo, input.files[0])
					.then( file => {
                        this.file = file
                        this.uploading=false;
                        this.$emit('uploaded', file)
                        this.$emit('input', file)
                        return file;
					})
					.catch(err => {
                        console.log(err)
                        this.$toast.error('Error al subir la imagen')
                        this.uploading=false;
						return false;
					});
				}	
			}
            this.uploading=false;
		},
		remove(image){
			this.images.forEach( (existentImage, index) => {
				if( image.id == existentImage.id){
					this.$emit('deleted',index);
				}
			});
		},
	}
};
</script>

<style scoped>
.image-form .boxes{
    width: 100%;
    display: flex;
}

.image-form .upload-box{
    min-width: 200px;
    min-height: 110px;
    border: 2px dashed rgba(28,110,164,.2);
    margin: 30px 0;
    padding: 33.5px;
    border-radius: 8px;
    position:relative;
    display: flex;
    align-items: center;
    justify-content:center;
    background-color: #fff; 
    flex-grow: 1;
    cursor: pointer;   
}
.image-form .upload-box.invalid{
    border-color: #dc3545;
}
.image-form .upload-box .invalid-feedback{
    position: absolute;
    bottom: -22px;
}
.image-form .upload-box .background{
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    top: 0px;
    width: 100%;
    height: 100%;

}
.image-form .upload-box p{
    margin: 0px;
    text-transform: uppercase;
    color: #adb5bd;
    font-size: 12px;
    font-weight: 600;
}
.image-form .upload-box p.with-file{
    position: absolute;
    top: -22px;
    left: 0px;
    font-size: 12px;
    color: #797979;
    margin-bottom: 0px;
    padding-bottom: 0px;
    font-weight: 300;
    text-transform: capitalize;
}
.image-form .upload-box input{
    opacity:0;
    position: absolute;
    z-index: 10;
    top: 0px;
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.image-form .upload-box:hover{
    background-color: #f1f1f1; 
}


.image-form .loading{
    position: absolute;
    border:none;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.4); 
    display: flex;
    align-items: center;
    justify-content:center;
    flex-flow: column;
    color: #fff;
    opacity: 1;
    cursor: pointer;
}

.image-form .loading i{
    font-size: 34px;
}
/* 

.avatar{
    width: 140px;
	height: 140px;
	border-radius: 90px;
    background-color: #ccc;
    display: block;
    background-size: cover;
    background-position: center center;
}
.avatar:after {
  content: "";
  display: block;
  padding-bottom: 100%;
} */


</style>
